import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/* axios instance shared by every page.
 *
 * Auth strategy:
 *   • `withCredentials: true` ensures the browser sends our HttpOnly
 *     `bp_session` cookie on every request. This is the primary auth
 *     channel — the JWT is stored only in the cookie (not localStorage),
 *     so an XSS attacker can't read it.
 *   • As a transitional fallback we also forward a Bearer token from the
 *     non-sensitive `bp:auth:legacy_token` slot if something *explicitly*
 *     stashed one there (e.g. native mobile webview that can't carry cookies).
 *     We deliberately *don't* store the token from a normal browser login.
 */
export const api = axios.create({
  baseURL: API,
  timeout: 15000,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  try {
    const legacy = localStorage.getItem("bp:auth:legacy_token");
    if (legacy && !cfg.headers.Authorization) {
      cfg.headers.Authorization = `Bearer ${legacy}`;
    }
  } catch {
    // private mode / disabled storage — fine, cookie path still works.
  }
  return cfg;
});

export const money = (cents) => {
  if (cents === null || cents === undefined) return "$0.00";
  const neg = cents < 0;
  const abs = Math.abs(cents);
  return `${neg ? "-" : ""}$${(abs / 100).toFixed(2)}`;
};

// Sanitize a free-typed currency string: keep digits + a single decimal
// point, cap to 2 decimal places. Crucially does NOT force ".00" so the
// cashier can type multi-digit amounts naturally (e.g. "15" then ".00").
export const sanitizeMoneyText = (raw) => {
  let v = String(raw ?? "").replace(/[^0-9.]/g, "");
  const dot = v.indexOf(".");
  if (dot !== -1) {
    const intPart = v.slice(0, dot);
    const decPart = v.slice(dot + 1).replace(/\./g, "").slice(0, 2);
    v = `${intPart}.${decPart}`;
  }
  return v;
};

export const moneyTextToCents = (text) => {
  const n = parseFloat(text);
  return Number.isFinite(n) ? Math.round(n * 100) : 0;
};

